export const P0003606TypeCorrecteurPh = [
  { ref: 0, label: 'P0003606.installation.ph-' },
  { ref: 1, label: 'P0003606.installation.ph+' },
];
